import type { Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';
import type { Conversation as ConversationUIComponent } from '@atlassian/conversation-assistant-ui-components/types';

import { isEmptyConversation } from '../../../controllers/chat-store/utils';

export const mapConversationToConversationUIComponent = (
	conversation: Conversation,
): ConversationUIComponent => {
	return {
		id: conversation.id,
		name: conversation.name,
		lastMessageTimestamp: conversation.lastMessageTimestamp,
		isEmpty: isEmptyConversation(conversation.id),
	};
};
